<div class="btn-wrapper">
  <button type="button"
          class="btn btn-block btn-outline-primary btn-comprar round">
    <!-- COMPRAR --> &nbsp;
  </button>
</div>